import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import 'react';
import { Bars } from './loaders/Bars.js';
import { Dots } from './loaders/Dots.js';
import { Oval } from './loaders/Oval.js';
import defaultStyles from './styles/Loader.module.scss.js';
import { jsx } from 'react/jsx-runtime';

const LOADERS = {
  bars: Bars,
  oval: Oval,
  dots: Dots
};
const LOADER_SIZES = {
  xs: 18,
  sm: 22,
  md: 36,
  lg: 44,
  xl: 58
};
const Loader = props => {
  const {
    size = 'md',
    color = '#519DFC',
    variant,
    customIconSize,
    theme
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  const defaultLoader = variant in LOADERS ? variant : 'oval';
  const defaultSize = customIconSize || LOADER_SIZES[size];
  const Element = LOADERS[defaultLoader] || LOADERS.bars;
  return /*#__PURE__*/jsx("span", {
    role: "presentation",
    className: styles.root,
    children: /*#__PURE__*/jsx(Element, {
      color: color,
      customIconSize: defaultSize
    })
  });
};
Loader.displayName = 'Loader';

export { LOADER_SIZES, Loader };
